mutation SetSupportRequestStatus(
  $id: ID!
  $input: SetSupportRequestStatusInput!
) {
  setSupportRequestStatus(id: $id, input: $input) {
    id
    status
    waitingSince
    closedAt
  }
}
